"use client"

import React from 'react'
import { FaWhatsapp } from 'react-icons/fa'

interface CtaWhatsAppProps {
  phone?: string
  message?: string
  size?: 'sm' | 'md' | 'lg'
  className?: string
}

export default function CtaWhatsApp({
  phone = '+216 98 148 481',
  message = "Bonjour, j'aimerais en savoir plus sur vos produits",
  size = 'md',
  className = '',
}: CtaWhatsAppProps) {
  // Normalize phone: remove non-digit characters, keep leading + removed for wa.me
  const digits = phone.replace(/[^0-9]/g, '')
  const encoded = encodeURIComponent(message)
  const href = `https://wa.me/${digits}?text=${encoded}`

  const sizes = {
    sm: {
      container: 'p-2',
      icon: 'h-4 w-4',
      text: 'text-xs',
      bubble: 'right-8 px-2 py-1 text-xs'
    },
    md: {
      container: 'p-3',
      icon: 'h-5 w-5',
      text: 'text-sm',
      bubble: 'right-10 px-3 py-1.5 text-sm'
    },
    lg: {
      container: 'p-4',
      icon: 'h-6 w-6',
      text: 'text-base',
      bubble: 'right-12 px-4 py-2 text-base'
    },
  }

  const [isHovered, setIsHovered] = React.useState(false)

  return (
    <div className="fixed bottom-72 right-6 z-50 flex items-center">
      {/* Speech Bubble with Text */}
      <div
        className={`
          absolute bg-white text-gray-800 rounded-lg shadow-lg font-medium transition-all duration-300 ease-in-out
          ${sizes[size].bubble}
          ${isHovered ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-4 pointer-events-none'}
          whitespace-nowrap border border-green-200
        `}
        style={{
          top: '50%',
          transform: isHovered ? 'translateY(-50%) translateX(0)' : 'translateY(-50%) translateX(4px)'
        }}
      >
        najmou n3wnouk !
        {/* Speech bubble triangle */}
        <div
          className="absolute top-1/2 -right-1 w-2 h-2 bg-white transform -translate-y-1/2 rotate-45 border-r border-t border-green-200"
          style={{ right: '-4px' }}
        />
      </div>

      {/* WhatsApp Button */}
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Contactez-nous sur WhatsApp - najmou n3wnouk !"
        className={`
          inline-flex items-center justify-center rounded-full bg-green-600 text-white 
          shadow-lg hover:shadow-xl transition-all duration-300 ease-in-out
          hover:bg-green-700 hover:scale-110 focus:outline-none focus:ring-4 focus:ring-green-400 focus:ring-opacity-50
          ${sizes[size].container} ${className}
        `}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        onFocus={() => setIsHovered(true)}
        onBlur={() => setIsHovered(false)}
      >
        <FaWhatsapp className={`${sizes[size].icon}`} />


      </a>
    </div>
  )
}